import React from "react";
import { Modal, Button } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";

export interface WarningModalProps {
  show: boolean;
  onHide: () => void;
  warningModalData: Record<number, string[]>;
}

export const WarningModal: React.FC<WarningModalProps> = ({
  show,
  onHide,
  warningModalData,
}) => {
  const getClientNameById = (id: number, clients: any[]): string => {
  const client = clients.find((c) => c.ClientMasterId === id);
  return client?.["Client Name"] ?? `Client ${id}`;
};

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      keyboard={false}
    >
      <Modal.Header></Modal.Header>
      <Modal.Body style={{ padding: "0px 30px" }}>
        <div className="flex-column-start-center">
          <div className="flex-row-center-start">
            <Icon.ExclamationOctagonFill
              color="orange"
              style={{ fontSize: 40, marginRight: 20, marginLeft: 15 }}
            />
            <h6>
              Please make sure that all the fields required for the engagement
              letter are filled.
            </h6>
          </div>
          <br />
          <div>
            Following fields are missing:
            <ul style={{ paddingLeft: "20px", marginTop: "10px" }}>
              {Object.entries(warningModalData).map(([clientId, fields]) => (
                <div key={clientId} style={{ marginBottom: "10px" }}>
                  <ul style={{ marginTop: "5px" }}>
                    {fields.map((field, i) => (
                      <li key={i}>{field}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </ul>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer
        style={{ justifyContent: "flex-end", margin: "0px 10px 10px 10px" }}
      >
        <div>
          <Button
            className="custom-button"
            onClick={() => {
              onHide();
            }}
          >
            Ok
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
